import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer className="bg-pep-navy text-white mt-32" data-testid="main-footer">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
                <div className="md:col-span-2">
                    <div className="inline-flex items-center bg-white rounded-2xl px-4 py-3 mb-5">
                        <img
                            src="https://customer-assets.emergentagent.com/job_peptide-premium/artifacts/xpnt0e9t_PNG%20image.PNG"
                            alt="PepStep"
                            className="h-7 w-auto"
                        />
                    </div>
                    <p className="text-white/60 text-sm max-w-md leading-relaxed">
                        Premium research peptides for serious researchers. Lab-tested purity,
                        transparent sourcing, discreet shipping.
                    </p>
                    <p className="text-white/40 text-xs mt-6 max-w-md leading-relaxed">
                        For research use only. Not for human consumption. Products sold by PepStep
                        are intended solely for in-vitro and laboratory research purposes.
                    </p>
                </div>
                <div>
                    <h4 className="font-heading text-sm uppercase tracking-widest text-white/40 mb-4">
                        Shop
                    </h4>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/all" data-testid="footer-link-all" className="text-white/80 hover:text-white">All Products</Link></li>
                        <li><Link to="/bundles" data-testid="footer-link-bundles" className="text-white/80 hover:text-white">Bundles</Link></li>
                        <li><Link to="/track" data-testid="footer-link-track" className="text-white/80 hover:text-white">Track Order</Link></li>
                    </ul>
                </div>
                <div>
                    <h4 className="font-heading text-sm uppercase tracking-widest text-white/40 mb-4">
                        Company
                    </h4>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/about" data-testid="footer-link-about" className="text-white/80 hover:text-white">About Us</Link></li>
                        <li><Link to="/contact" data-testid="footer-link-contact" className="text-white/80 hover:text-white">Contact</Link></li>
                        <li><Link to="/terms" data-testid="footer-link-terms" className="text-white/80 hover:text-white">Terms of Service</Link></li>
                        <li><Link to="/privacy" data-testid="footer-link-privacy" className="text-white/80 hover:text-white">Privacy Policy</Link></li>
                        <li><Link to="/disclaimer" data-testid="footer-link-disclaimer" className="text-white/80 hover:text-white">Research Disclaimer</Link></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/10">
                <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-white/40 text-xs">
                        © {new Date().getFullYear()} PepStep. All rights reserved.
                    </p>
                    <div className="flex gap-3 text-white/40 text-xs">
                        <span>Bank Transfer</span>
                        <span>•</span>
                        <span>Discreet Shipping</span>
                        <span>•</span>
                        <span>Lab-Verified</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
